import { request } from "../../../config/helpers/axios-instance";
import { useQuery } from "react-query";

// refetchInterval as a function so polling halts itself once the job reaches a terminal
// status, instead of hammering the API forever.
const fetchLsqTransferJob = (jobId, enabled = true) => {
    return useQuery(
        ["lsq-transfer-job", jobId],
        () =>
            request({
                url: `lsq/admin/transfer/${jobId}`,
                method: "GET",
            }),
        {
            enabled: enabled && Boolean(jobId),
            refetchInterval: (data) => {
                const status = data?.data?.data?.status;
                return status === "QUEUED" || status === "RUNNING" ? 5000 : false;
            },
        }
    );
};

export { fetchLsqTransferJob };
